<template>
    <div class="messageTemplate">
        <div class="searchForm">
            <el-form ref="form" :model="form" label-width="75px" @submit.native.prevent>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="查询条件">
                            <el-input v-model="form.name" autocomplete="off" placeholder="输入模板名称"
                                @keyup.enter.native="getTemplateList(1)" />
                        </el-form-item>
                        <el-form-item label="模板类型" style="margin-left: 10px">
                            <el-select v-model="form.type" clearable placeholder="请选择模板类型" @change="getTemplateList(1)">
                                <el-option v-for="item in templateOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-button type="primary" style="margin-left: 30px;" @click="getTemplateList(1)">查询</el-button>
                        <el-button type="primary" @click="showEditDialog(0)">新增</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="dataBox">
            <el-table v-loading="loading" element-loading-text="数据加载中" :data="tableData" stripe max-height="700">
                <el-table-column prop="code" label="模板编码" />
                <el-table-column prop="name" label="模板名称" />
                <el-table-column prop="type" label="模板类型">
                    <template slot-scope="scope">
                        <span>{{ parseTemplateType(scope.row.type, scope.row.qwType) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序编号" />
                <el-table-column prop="createDate" sortable label="创建时间">
                    <template slot-scope="scope">
                        <span>{{ parseTime(scope.row.createDate) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="是否有效" width="120">
                    <template slot-scope="scope">
                        {{ scope.row.status === 0 ? '有效' : '无效' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="250">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showEditDialog(1, scope.row)">编辑</el-button>
                        <el-popover trigger="click" :ref="`popover-${scope.$index}`" placement="top" width="100">
                            <p class="el-icon-warning">确认删除吗？</p>
                            <div style="text-align: right; margin: 0">
                                <el-button size="mini" type="text"
                                    @click="scope._self.$refs[`popover-${scope.$index}`].doClose()">取消
                                </el-button>
                                <el-button type="primary" size="mini" @click="deleteRow(scope)">确定</el-button>
                            </div>
                            <el-button style="margin-left: 10px" type="text" slot="reference">删除</el-button>
                        </el-popover>
                    </template>

                </el-table-column>

            </el-table>
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
                :page-sizes="[10, 20, 50]" :page-size="pageSize" :current-page.sync="pageNum" @size-change="sizeChangeClick"
                @current-change="currChangeClick" @prev-click="prevClick" @next-click="nextClick" />
        </div>
        <!-- 编辑弹框 -->
        <el-dialog :title="(operateType === 0 ? '新增' : '编辑') + '模板'" :visible.sync="dialogEditFormVisible" width="70%"
            :before-close="closeDialog">
            <el-form :model="editForm" ref="editForm" label-width="120px" :rules="rules">
                <el-form-item label="模板编码" prop="code">
                    <el-input maxlength="30" v-model="editForm.code" placeholder="请输入模板编码" />
                </el-form-item>
                <el-form-item label="模板名称" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入模板名称" />
                </el-form-item>
                <el-form-item label="模板类型" prop="type">
                    <el-radio-group v-model="editForm.type" size="medium">
                        <el-radio v-for="(item, index) in templateOptions" :key="index" :label="item.value"
                            :disabled="item.disabled">{{ item.label }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="企微消息类型" prop="qwType" v-if="editForm.type === 1">
                    <el-radio-group v-model="editForm.qwType" size="medium">
                        <el-radio v-for="(item, index) in qwMessageOptions" :key="index" :label="item.value"
                            :disabled="item.disabled">{{ item.label }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input-number v-model="editForm.sort" placeholder="排序" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="标题" prop="title" v-if="showFormInput('title')">
                    <el-input v-model="editForm.title" placeholder="请输入标题,如需使用占位符请用{code}标识" :style="{ width: '100%' }">
                    </el-input>
                </el-form-item>
                <!-- 系统模板 -->
                <el-form-item label="系统模板" prop="askSystem" v-if="showFormInput('askSystem')">
                    <el-switch v-model="askSystem" active-color="#13ce66" inactive-color="#CCCCCC">
                    </el-switch>
                </el-form-item>
                <el-form-item label="系统模板选择" prop="select" v-if="showFormInput('select')">
                    <el-select @change="selectData" @clear="accountClick()" clearable filterable :filter-method="dataFilter"
                        v-model="editForm.select" placeholder="请选择">
                        <el-option v-for="item in selectoptions" :key="item.code" :label="item.name" :value="item.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="标题" prop="title" v-if="showFormInput('title')">
                    <el-input v-model="editForm.title" placeholder="请输入标题,如需使用占位符请用{code}标识" :style="{ width: '100%' }">
                    </el-input>
                </el-form-item> -->
                <el-form-item label="内容" prop="content" v-if="showFormInput('contentMail')"
                    :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                    <!-- <editor-bar v-model="editForm.content" :is-clear="true"
                                placeholder="请输入内容,如需使用占位符请用{}标识"/> -->
                    <part-tinymce v-model="editForm.content" :is-clear="true"
                        placeholder="请输入内容,如需使用占位符请用{}标识"></part-tinymce>
                </el-form-item>
                <el-form-item label="内容" prop="content" v-if="showFormInput('content')"
                    :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                    <el-input v-model="editForm.content" type="textarea" placeholder="请输入内容,如需使用占位符请用{code}标识"
                        :autosize="{ minRows: 4, maxRows: 4 }" :style="{ width: '100%' }"></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="description" v-if="showFormInput('description')">
                    <el-input v-model="editForm.description" type="textarea" placeholder="请输入描述,如需使用占位符请用{code}标识"
                        :autosize="{ minRows: 4, maxRows: 4 }" :style="{ width: '100%' }"></el-input>
                </el-form-item>
                <el-form-item label="跳转链接" prop="url" v-if="showFormInput('url')">
                    <el-input v-model="editForm.url" placeholder="请输入跳转链接,如需使用占位符请用{code}标识" :style="{ width: '100%' }">
                    </el-input>
                </el-form-item>
                <el-form-item label="图片链接" prop="picUrl" v-if="showFormInput('picUrl')">
                    <el-input v-model="editForm.picUrl" placeholder="请输入图片链接,如需使用占位符请用{code}标识" :style="{ width: '100%' }">
                    </el-input>
                </el-form-item>
                <el-form-item label="按钮文字" prop="btnTxt" v-if="showFormInput('btnTxt')">
                    <el-input v-model="editForm.btnTxt" placeholder="请输入按钮文字,如需使用占位符请用{code}标识"></el-input>
                </el-form-item>
                <el-form-item label="是否有效">
                    <el-switch style="display: block" v-model="editForm.status" active-color="#13ce66"
                        inactive-color="#ff4949" active-text="是" inactive-text="否" :active-value="0" :inactive-value="1">
                    </el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogEditSave">保存</el-button>
                <el-button type="primary" @click="closeDialog">取消</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import EditorBar from '@/components/editor'
import partTinymce from '@/components/partTinymce'
import { parseTime } from "@/util/index";
import httpUrl from "@/static/configUrl";
import { Message, Table, TableColumn } from 'element-ui';

export default {
    name: 'msgTemplate',
    components: {
        EditorBar,
        Message,
        Table,
        TableColumn,
        partTinymce
    },
    data() {
        const validenDesc = (rule, value, callback) => {
            if (this.editForm.qwType === 3) {
                if (!value) {
                    callback(new Error("请输入描述内容"));
                } else {
                    callback()
                }
            } else {
                callback()
            }
        };

        return {
            // clientId: this.$store.state.request.appId,
            form: {
                name: '',
                // status: 0,
                type: undefined
            },
            templateOptions: [{
                "label": "企微",
                "value": 1
            }, {
                "label": "短信",
                "value": 2
            }, {
                "label": "邮件",
                "value": 3
            }
            ],
            qwMessageOptions: [{
                "label": "文本消息",
                "value": 1
            }, {
                "label": "图文消息",
                "value": 2
            }, {
                "label": "卡片消息",
                "value": 3
            }
            ],
            tableData: [],
            total: 0,
            pageNum: 1,
            pageSize: 10,
            loading: false,
            dialogEditFormVisible: false,
            operateType: 0,
            // 编辑的form表单
            editForm: {
                clientId: this.$store.state.request.appId,
                id: '',
                code: '',
                name: '',
                type: 1,
                qwType: 1,
                status: 0,
                sort: undefined,
                title: '',
                content: '',
                description: '',
                url: '',
                picUrl: '',
                btnTxt: '',
                select: '',

            },
            // 系统模板
            // 是否系统模板
            askSystem: false,
            selectoptions: [],
            selectoptionslist2: [],
            dialogFormVisible: false,
            visible: false,
            rules: {
                code: [
                    { required: true, message: '请输入模板编码', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入模板名称', trigger: 'blur' }
                ],
                type: [
                    { required: true, trigger: 'blur', message: '请选择模板类型' }
                ],
                qwType: [
                    { required: true, trigger: 'blur', message: '请选择企微消息类型' }
                ],
                title: [
                    { required: true, trigger: 'blur', message: '请输入标题' }
                ],
                description: [
                    { trigger: 'blur', validator: validenDesc }
                ],
                url: [
                    { required: true, trigger: 'blur', message: '请输入跳转链接' }
                ],
                btnTxt: [
                    { required: true, trigger: 'blur', message: '请输入按钮文字' }
                ]
            },
        }
    },
    computed: {
        clientId(){
            return this.$store.state.request.appId
        }
    },
    watch:{
        clientId() {
            this.getTemplateList()
            this.getsystemlist()// 获取系统模板
        }
    },
    created() {
        this.getTemplateList()
        this.getsystemlist()// 获取系统模板
    },
    mounted() {
    },
    methods: {
        parseTime,
        parseTemplateType(type, qwType) {
            switch (type) {
                case 1:
                    let msgType = "企微-"
                    let qwMsgType = ""
                    switch (qwType) {
                        case 1:
                            qwMsgType = "文本消息"
                            break;
                        case 2:
                            qwMsgType = "图文消息"
                            break;
                        case 3:
                            qwMsgType = "卡片消息"
                            break;
                        default:
                            break;
                    }
                    return msgType + qwMsgType
                case 2:
                    return "短信模板"
                case 3:
                    return "邮件模板"
                default:
                    return "未知类型"
            }
        },
        getTemplateList(_pageNum) {
            const that = this
            if (_pageNum === 1) {
                that.pageNum = 1
            }
            that.loading = true
            this.$store.dispatch('httpGet', {
                curl: httpUrl.messageUrl + "/template/list",
                clientId: that.clientId,
                name: that.form.name,
                type: that.form.type,
                status: that.form.status,
                page: that.pageNum,
                size: that.pageSize
            }).then(function (res) {
                that.tableData = res.data.content
                that.total = parseInt(res.data.total)
                that.loading = false
            }, function (err) {
                console.log(err.message)
                that.loading = false
            })
        },
        getsystemlist() {
            const that = this
            that.loading = true
            this.$store.dispatch('httpGet', {
                curl: httpUrl.messageUrl + "/template/list",
                askSystem: true,
                clientId:'system'
            }).then(function (res) {
                that.selectoptions = res.data
                that.selectoptionslist2 = res.data
                that.loading = false
            }, function (err) {
                console.log(err.message)
                that.loading = false
            })
        },
        // 分页 每页条数改变
        sizeChangeClick(val) {
            this.pageSize = val
            this.getTemplateList()
        },
        // 分页 改变当前页
        currChangeClick(val) {
            this.pageNum = val
            this.getTemplateList()
        },
        // 分页 上一页
        prevClick(val) {
            this.pageNum = val
            this.getTemplateList()
        },
        // 分页 下一页
        nextClick(val) {
            this.pageNum = val
            this.getTemplateList()
        },
        // 编辑-弹出窗
        showEditDialog(operType, rowData) {
            this.editForm = {
                clientId: this.$store.state.request.appId,
                id: '',
                code: '',
                name: '',
                type: 1,
                qwType: 1,
                status: 0,
                sort: undefined,
                title: '',
                content: '',
                description: '',
                url: '',
                picUrl: '',
                btnTxt: '',
            }
            this.askSystem = false
            this.operateType = operType
            if (operType === 1) {
                let tmp_content = rowData.content
                if (tmp_content.indexOf('<pre><code>') !== -1) {
                    rowData.content = rowData.description
                }
                this.editForm = {
                    clientId: this.clientId,
                    id: rowData.id,
                    code: rowData.code,
                    name: rowData.name,
                    type: rowData.type,
                    qwType: rowData.qwType,
                    status: rowData.status,
                    sort: rowData.sort,
                    title: rowData.title,
                    content: rowData.content,
                    description: rowData.description,
                    url: rowData.url,
                    picUrl: rowData.picUrl,
                    btnTxt: rowData.btnTxt,
                }
            }
            this.getsystemlist()
            this.dialogEditFormVisible = true
        },
        // 编辑-保存
        dialogEditSave() {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    const that = this
                    let _funName = '/template/add'
                    let httpType = 'httpPost'
                    if (that.operateType === 1) {
                        _funName = '/template/update'
                        httpType = 'httpPut'
                    }
                    this.$set(this.editForm, 'curl', httpUrl.messageUrl + _funName)
                    that.$store.dispatch(httpType, this.editForm).then(function (res) {
                        that.$message({
                            message: '保存成功',
                            type: 'success',
                            duration: 500,
                            onClose: function () {
                                that.dialogEditFormVisible = false
                                that.getTemplateList()
                            }
                        })
                    }, function (err) {
                        that.$message({
                            message: err.message,
                            type: 'warning'
                        })
                    })
                    return true
                } else {
                    return false
                }
            })
        }, closeDialog() {
            this.dialogEditFormVisible = false;
            this.selectoptions = this.selectoptionslist2;
            this.$refs['editForm'].clearValidate();
        },
        //根据消息类型动态展示form表单输入框
        showFormInput(attr) {
            let msgType = this.editForm.type
            let qwMsgType = this.editForm.qwType
            switch (attr) {
                case 'title':
                    if (msgType === 3) {
                        return true;
                    } else if (msgType === 1) {
                        //文本消息=1 图文消息=2 卡片消息=3
                        if (qwMsgType === 2 || qwMsgType === 3) {
                            return true;
                        }
                    }
                    return false;
                case 'contentMail':
                    if (msgType === 3) {
                        return true;
                    }
                    return false;
                // 系统模板
                case 'select':
                    if (msgType === 3 & this.askSystem === true) {
                        return true;
                    }
                    return false;
                case 'askSystem':
                    if (msgType === 3) {
                        return true;
                    }
                    return false;
                case 'content':
                    if (msgType === 3) {
                        return false;
                    }
                    if (msgType === 1) {
                        if (qwMsgType === 2 || qwMsgType === 3) {
                            return false;
                        }
                    }
                    return true;
                case 'description':
                    if (msgType === 1) {
                        if (qwMsgType === 2 || qwMsgType === 3) {
                            return true;
                        }
                    }
                    return false;
                case 'url':
                    if (msgType === 1) {
                        if (qwMsgType === 2 || qwMsgType === 3) {
                            return true;
                        }
                    }
                    return false;
                case 'picUrl':
                    if (msgType === 1) {
                        if (qwMsgType === 2) {
                            return true;
                        }
                    }
                    return false;
                case 'btnTxt':
                    if (msgType === 1) {
                        if (qwMsgType === 3) {
                            return true;
                        }
                    }
                    return false;
                default:
                    return false;
            }
        },
        // 系统模板选择检索
        //自定义搜索方法
        dataFilter(val) {
            // this.editForm.select = val;
            if (val) { //val存在
                this.selectoptions = this.selectoptionslist2.filter((item) => {
                    // if (!!~item.label.indexOf(val) || !!~item.label.toUpperCase().indexOf(val.toUpperCase())) {
                    if (!!~item.name.indexOf(val) || !!~item.code.indexOf(val) || !!~item.name.toUpperCase().indexOf(val.toUpperCase())) {
                        return true
                    }
                })
            } else { //val为空时，还原数组
                this.selectoptions = this.selectoptionslist2;
            }
            console.log("pph8866", this.selectoptions)
        },
        accountClick() {
            this.selectoptions = this.selectoptionslist2;
        },
        // 选择模板
        selectData(val) {
            console.log(99999000, val)
            this.selectoptionslist2.forEach((item => {
                if (item.code === val) {
                    this.editForm.content = item.content
                }
            }))
        },
        //删除
        deleteRow(scope) {
            debugger
            const that = this
            const data = {
                curl: httpUrl.messageUrl + "/template/delete?id=" + scope.row.id,
            }
            that.$store.dispatch('httpDelete', data).then(function (res) {
                that.$message({
                    message: '删除成功',
                    type: 'success',
                    duration: 500,
                    onClose: function () {
                        that.dialogEditFormVisible = false
                        that.getTemplateList()
                    }
                })
            })
            scope._self.$refs[`popover-${scope.$index}`].doClose()
        }
    }
}
</script>

<style lang="scss" scoped>
.messageTemplate {
    .searchForm {
        /*background: #fff;*/
        /*height: 45px;*/
        /*padding-top: 10px;*/
        padding-left: 10px;

        .el-input {
            width: 200px;
        }
    }

    .dataBox {
        /*background: #fff;*/
        /*padding: 10px 15px 20px;*/
        /*padding-top: 50px;*/

    }
}
</style>
<style>
.messageTemplate .searchForm .el-form-item {
    display: inline-block;
}

.messageTemplate .searchForm .el-form-item:nth-child(2) {
    margin-left: 30px;
}
</style>
